import { Card, CardBody, Flex, Heading, VStack } from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import { Select } from "chakra-react-select";
import { fetchController } from "../../utils/FetchController/fetchController";
import Loader from "../../utils/Loader/Loader";
import { getHostDomain } from "../../utils/utils";
import Layout from "../Layout/Layout";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import { getWidgetProvider } from "../Widgets/utils";
import IframeWidget from "./IframeWidget";
import ImageIconWidgetOption from "./ImageIconWidgetOption";

export default function PlaygroundPage() {
  const baseUrl = getHostDomain();
  const [widgets, setWidgets] = useState([]);
  const [status, setStatus] = useState("idle");

  useEffect(() => {
    (async () => {
      try {
        setStatus("loading");
        const endpoint = "/api/v1/widget/get_my_details?page=1&size=50";
        const urlHit = baseUrl + endpoint;
        const response = await fetchController(urlHit, "GET");
        setWidgets(response.data.items);
      } catch (error) {
        console.error(error);
      } finally {
        setStatus("idle");
      }
    })();
  }, []);

  const loading = status === "loading";

  const [widget, setWidget] = useState({
    id: "",
    type: "",
  });

  const onChangeWidget = (widget) => {
    setWidget({
      id: widget.id,
      type: widget.type,
    });
  };

  const selectPlaceholder = widgets.length
    ? "Select widget to start the chat"
    : "Please create a widget first";

  const agency = useContext(AgencyContext);
  const { textColor } = agency;
  const name = agency?.myDetails?.agency_id
    ? agency?.myDetails?.branding?.agency_name
    : "Insighto.AI";

  const widgetOptions = widgets
    .filter((widget) =>
      ["web_call", "html_call", "chat"].includes(widget.widget_type)
    )
    .map((widget) => ({
      label: `${widget.name} [${widget.id}]`,
      value: widget.id,
      type: widget.widget_type,
      src: getWidgetProvider({
        type: widget?.widget_type,
        name,
        logo: agency?.faviconUrl,
      }).logo,
    }));

  return (
      <VStack
        h="100%"
        spacing={2}
        justifyContent={"space-between"}
        borderRadius="md"
      >
        <Flex
          direction={"column"}
          gap={3}
          h={"100%"}
          w={"100%"}
          overflowY={"auto"}
        >
          <Flex gap={2} w={"100%"} alignItems="center" p={2}>
            <Heading color={textColor} fontSize="xl">
              Playground
            </Heading>

            <Select
              disabled={widgets.length === 0}
              placeholder={selectPlaceholder}
              onChange={(widget) => {
                onChangeWidget({
                  id: widget.value,
                  type: widget.type,
                });
              }}
              options={widgetOptions}
              components={{ Option: ImageIconWidgetOption }}
              value={widgetOptions.find((w) => w.id === widget.id)}
              isLoading={loading}
            />
          </Flex>

          {loading ? (
            <Loader />
          ) : (
            <>
              {widget.id ? (
                <Card variant="elevated">
                  <CardBody>
                    <Flex
                      w={"100%"}
                      alignItems="center"
                      justifyContent="center"
                      mt={2}
                      overflowY="auto"
                    >
                      <IframeWidget
                        widgetId={widget.id}
                        widgetType={widget.type}
                      />
                    </Flex>
                  </CardBody>
                </Card>
              ) : null}
            </>
          )}
        </Flex>
      </VStack>
  );
}
